
import { ActivitySelectedFiltersBase } from '../selected-filters-base';

import './style.scss';

interface IProps {
  isVacationRentals?: boolean | null | undefined;
  isCars?: boolean | null | undefined;
  onFiltersOrSortChange: (isSortChange?: boolean) => void;
}
export function ActivitySelectedFiltersHeader(props: IProps) {
  const { onFiltersOrSortChange } = props;

  return (
    <ActivitySelectedFiltersBase  onFiltersOrSortChange={onFiltersOrSortChange} displayClearAllHeader />
  );
}
